export class TransitionalInventoryParam {
    FacilityId: string;
    CustomerId: string;
    StartDate: Date | null = null;
    EndDate: Date | null = null;
    SummaryType: string;
};


// WEBPACK FOOTER //
// ./src/app/models/TransitionalInventoryParam.ts